import { render, staticRenderFns } from "./lookDialog.vue?vue&type=template&id=5a0427a7&scoped=true&"
import script from "./lookDialog.vue?vue&type=script&lang=js&"
export * from "./lookDialog.vue?vue&type=script&lang=js&"
import style0 from "./lookDialog.vue?vue&type=style&index=0&id=5a0427a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0427a7",
  null
  
)

export default component.exports